var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default"},[(_vm.role === 'guide')?_c('GreetingGuide'):(_vm.role === 'office' || _vm.role === 'admin')?_c('GreetingOffice'):_c('div',[_vm._v("You Have No Role, Contact your system administrator to ensure you have the proper access to mechski")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }